<template>
  <div v-if="loading" class="mc-loader"><span class="mc-loader__circle"></span></div>
  <div v-if="serverError" class="mc-wrapper">
    <div class="mc-container">
      <div class="mc-error" v-html="serverError"></div>
    </div>
  </div>
  <div v-if="loaded" class="mc-result-page">
    <div class="mc-result-page__body">
      Ваш заказ №{{ order.id }} принят.
      <template v-if="isAuth">
      Статус заказа можно отслеживать в <router-link class="to_personal" :to="'/order/'+order.id+'/'">Личном кабинете</router-link>.
      </template>
      <template v-else>
        Статус заказа можно отслеживать в <router-link class="to_personal" to="/profile/">Личном кабинете</router-link>.
      </template>
      <br><router-link class="to_personal" to="/">На главную</router-link>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import {mapActions} from "vuex";

export default {
  data() {
    return {
      loaded: false,
      order: {},
      serverError: '',
      loading: true
    }
  },
  mounted() {

  },
  computed: {
    id() {
      return this.$route.query.ORDER_ID;
    },
    isAuth() {
      return this.$store.getters.isAuth;
    }
  },
  async created() {
    let responseAuth = await axios.post('/api/user/', {
     /* device: device,
      device_uuid: device_uuid*/
    })
    let data = responseAuth.data;
    data.device = this.$store.getters.device;
    data.uuid = this.$store.getters.device_uuid;
    this.$store.dispatch('AuthRepeat', data.data)


    const response = await axios.get('api/order/success/'+this.$route.query.ORDER_ID+'/');

    if (response.data.status == 'error') {
      this.serverError= '';
      for (let i in response.data.errors) {
        console.log(typeof response.data.errors[i].code)
        if (typeof response.data.errors[i].code != 'number' && response.data.errors[i].code!= 'cert')
          this.errors[response.data.errors[i].code] = response.data.errors[i].message;
        else
          this.serverError += response.data.errors[i].message+"<br>";
      }
    }
    else {
      if (response.data.data.url) {
        this.fetchCounterData();
        window.location.href = response.data.data.url;
        return;
      }
      this.order = response.data.data;
      this.loaded = true;
    }
    this.fetchCounterData();
    this.loading = false;

  },
  components: {},
  methods: {
    ...mapActions([
      'fetchCounterData'
    ]),
  },
}
</script>

